import { combineReducers } from 'redux';

import data from 'modules/publicToken/reducer/data';
import ui from 'modules/publicToken/reducer/ui';

const publicToken = combineReducers({
  data,
  ui,
});

export type PublicTokenReducer = ReturnType<typeof publicToken>;

export default publicToken;
